import { useState, useEffect } from 'react';

const Alert = ({ message, setMessage, duration = 3000 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true); // Show the alert when there's a message

      const timeoutId = setTimeout(() => {
        setIsVisible(false); // Hide the alert after the duration
        // Reset the message state after the fade-out completes
        setTimeout(() => setMessage(''), 300); // Allow the transition to finish
      }, duration);

      return () => clearTimeout(timeoutId); // Cleanup timeout
    }
  }, [message, setMessage, duration]);

  const alertStyles = {
    wrapper: {
      opacity: isVisible ? 1 : 0,
      position: 'absolute',
      top: '4em',
      transition: 'opacity 0.3s ease',
      zIndex: 1000,
      pointerEvents: isVisible ? 'auto' : 'none',
    },
    alertBox: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'var(--uchu-light-blue)',
      color: 'var(--uchu-blue)',
      padding: '1em 1.5em',
      borderRadius: '0.25em',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
  };

  return (
    <div style={alertStyles.wrapper} role="alert" aria-live="assertive">
      <div style={alertStyles.alertBox}>
        {message}
      </div>
    </div>
  );
};

export default Alert;
